'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ADAHelper = require('../lib/ADAHelpers');

var pageTitle = function pageTitle(_ref) {
    var _ref$locationCancelHa = _ref.locationCancelHandler,
        locationCancelHandler = _ref$locationCancelHa === undefined ? '' : _ref$locationCancelHa,
        _ref$backHandler = _ref.backHandler,
        backHandler = _ref$backHandler === undefined ? '' : _ref$backHandler,
        _ref$imgAltText = _ref.imgAltText,
        imgAltText = _ref$imgAltText === undefined ? '' : _ref$imgAltText,
        _ref$titleText = _ref.titleText,
        titleText = _ref$titleText === undefined ? '' : _ref$titleText,
        _ref$pageTitleRole = _ref.pageTitleRole,
        pageTitleRole = _ref$pageTitleRole === undefined ? '' : _ref$pageTitleRole;

    var headerProps;

    if (pageTitleRole) {
        headerProps = { role: 'main' };
    }

    return _react2.default.createElement(
        'div',
        { className: 'page-title-container' },
        _react2.default.createElement(
            'div',
            { className: 'page-title-wrapper' },
            backHandler ? _react2.default.createElement('img', { tabIndex: '0', role: 'button', id: 'back-button', onClick: backHandler, onMouseEnter: hoverImage, onMouseLeave: hoverImage,
                src: '/images/common/icons/back_2.png', alt: imgAltText, onKeyDown: ADAHelper.keyupHandler }) : '',
            _react2.default.createElement(
                'h1',
                _extends({ className: 'page-title', tabIndex: '-1', id: 'page-title' }, headerProps),
                titleText
            ),
            locationCancelHandler ? _react2.default.createElement('img', { className: 'title-cancel-button', tabIndex: '0', role: 'button', id: 'cancel-button', onClick: locationCancelHandler,
                src: '/images/common/icons/ic_remove.png', alt: imgAltText, onKeyDown: ADAHelper.keyupHandler }) : ''
        ),
        _react2.default.createElement('hr', { role: 'presentation' })
    );
};

function hoverImage(e) {
    if (e.target.src.indexOf('_hover_2.png') > -1) {
        e.target.src = e.target.src.replace('_hover_2.png', '_2.png');
    } else {
        e.target.src = e.target.src.replace('_2.png', '_hover_2.png');
    }
}

exports.default = pageTitle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/components/pageTitle.js
// module id = 62
// module chunks = 0